
import React from 'react'
import Getxt from './Getxt';
import GetPosts from './GetPosts';
import { Link } from "react-router-dom"
import { Badge, Button } from "@material-ui/core"
import useStyles from "./styles"
import Lang from "../../Lang"
import { useSelector } from 'react-redux';

const Options = () => {

    const classes = useStyles()
    const user = JSON.parse(localStorage.getItem("profile"))
    const scores = useSelector((state) => state.scores)
    const unreadScoresCount = () => {
        let total = 0
        scores.myScores?.records.forEach(r => !r.seen && total++);
        return total
    }

    return (
        <div className={classes.main}>
            <main>
                <div className={classes.options}>
                    <Button className={classes.learn_button} component={Link} to="/learn" variant="outlined" color="default"><span className={classes.options_text}><Lang props={"Aprende"} /></span></Button>
                    <Button className={classes.practice_button} component={Link} to="/practice" variant="outlined" color="default"><span className={classes.options_text}><Lang props={"Practica"} /></span></Button>
                    <Button className={classes.compete_button} component={Link} to="/compete" variant="outlined" color="default">
                        <span className={classes.options_text}>
                            <Badge color="secondary" overlap="rectangular" badgeContent={unreadScoresCount()} anchorOrigin={{
                                vertical: 'top', horizontal: 'right',
                            }}>
                                <Lang props={"Compite"} />
                            </Badge>
                        </span>
                    </Button>
                </div>
            </main>
            <footer className={classes.footer}>
                <Getxt />
                <GetPosts />
                <Button disabled={!user} className={classes.footer_button} component={Link} to="/rss" variant="outlined" color="default"><Lang props={"Sigue leyendo"} /></Button>
            </footer>
        </div>

    )
}

export default Options
